import { render, staticRenderFns } from "./spSubscribe.vue?vue&type=template&id=5b72d43a&"
import script from "./spSubscribe.vue?vue&type=script&lang=js&"
export * from "./spSubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports